import axios from "axios";
import { Dispatch } from "redux";
import { sendConfig } from "../utils/headers";

import { ADMIN_FAIL, ADMIN_LOADING, ADMIN_SUCCESS, AdminDispatchTypes } from './adminActionType';

interface LoginPayloadI {

    phone: number,
    password: string
}

export const loginAdmin = ( payload: LoginPayloadI ) => async ( dispatch: Dispatch< AdminDispatchTypes > ) => {

    try {

        dispatch( { 
        
            type: ADMIN_LOADING
        
        } );
        
        axios.put( 'https://shreee-development-test.herokuapp.com/admin/signin', payload, sendConfig )
        .then( async ( data: any ) => {
            localStorage.setItem( "shreeDevToken", data.data.data[ 0 ].token );

            console.log( 'user data fetched on login ', data.data.data[ 0 ] );
            dispatch( { 

                type: ADMIN_SUCCESS,
                payload: data.data.data[ 0 ]
    
            } );
       } )
        .catch( async ( e: any ) => { 
            console.log( 'some error', e.response.data );
            dispatch( {

                type: ADMIN_FAIL,
                payload: e.response.data
            
            } );

        } )

        

    }
    catch( e ) {
        console.log( 'error occured', e );
        dispatch( {

            type: ADMIN_FAIL,
            payload: 'Some unknown Error'
        
        } )
    }

}
